import { Component, h } from "preact";

import Cropper from "cropperjs";
import { IImageMeta, ILabelOptionValue, IOption } from "../../../typings";
import Uploader from "../../uploader";
import OutputController from "../../../shared/controller/output-controller";
import SizeController from "../../../shared/controller/size-controller";
import ColorController from "../../../shared/controller/color-controller";
import TemplateController from "../../../shared/controller/template-controller";

export default class ImageCropper extends Component<
  IImageCropperProps,
  IImageCropperState
> {
  IMAGE: string;
  cropper: Cropper;

  constructor(props: IImageCropperProps) {
    super(props);

    this.state = {
      imageMeta: null,
    };

    this.saveImage = this.saveImage.bind(this);
    this.close = this.close.bind(this);
  }

  componentDidMount(): void {
    this.IMAGE = this.props.outputController.getValue([
      "image",
      this.props.originalPngName,
    ]);
    const imageMeta: IImageMeta = this.props.outputController.getValue([
      "image",
      this.props.originalMetaName,
    ]);
    this.setState(
      {
        imageMeta,
      },
      () => {
        const image: HTMLCanvasElement = document.getElementById(
          "cropper",
        ) as HTMLCanvasElement;
        if (image) {
          image.classList.remove("cropper-hidden");

          const imageData: Cropper.Data = this.props.outputController.getValue([
            "image",
            this.props.croppedDataName,
          ]);

          const options: Cropper.Options = {
            data: imageData,
            movable: false,
            rotatable: false,
            zoomable: false,
            zoomOnTouch: false,
            zoomOnWheel: false,
            toggleDragModeOnDblclick: false,
          };

          const optionWidth: IOption =
            this.props.templateController.getOptionByCode("width");
          const fixedWidth: ILabelOptionValue = optionWidth.attributes.fixed
            ? optionWidth.attributes.fixed.value
            : undefined;
          const optionHeight: IOption =
            this.props.templateController.getOptionByCode("height");
          const fixedHeight: ILabelOptionValue = optionHeight.attributes.fixed
            ? optionHeight.attributes.fixed.value
            : undefined;
          if (fixedWidth && fixedHeight) {
            options.aspectRatio = fixedWidth / fixedHeight;
          }

          this.cropper = new Cropper(image, options);
        }
      },
    );
  }

  componentWillUnmount(): void {
    if (this.cropper) {
      this.cropper.destroy();
    }
  }

  saveImage(): void {
    const canvas: HTMLCanvasElement = this.cropper.getCroppedCanvas();
    const imageData: Cropper.Data = this.cropper.getData();

    const image: string = canvas.toDataURL(this.state.imageMeta.type);
    this.props.colorController.updateColors(image);
    const imageMeta: IImageMeta = this.state.imageMeta;
    imageMeta.height = parseInt(imageData.height.toFixed(0));
    imageMeta.width = parseInt(imageData.width.toFixed(0));

    this.props.sizeController
      .setCroppedData(imageData)
      .then(() => {
        this.cropper.destroy();
        this.close();
      })
      .catch(() => {});
  }

  close(): void {
    this.props.onClose();
  }

  render(): JSX.Element {
    return (
      <div>
        <div>
          <img src={this.IMAGE && this.IMAGE} id="cropper" />
        </div>
        <div className="flex my-4">
          <button
            className="p-3 mx-auto font-bold rounded-md bg-blue-light text-blue"
            onClick={this.saveImage}
          >
            {this.props.option.meta.fields.cropperCropButton}
          </button>
          <button
            className="p-3 mx-auto font-bold rounded-md bg-blue-light text-blue"
            onClick={this.close}
          >
            {this.props.option.meta.fields.cropperCropCancelButton}
          </button>
        </div>
      </div>
    );
  }
}

interface IImageCropperProps {
  main: Uploader;
  onClose: Function;

  outputController: OutputController;
  sizeController: SizeController;
  colorController: ColorController;
  templateController: TemplateController;

  originalName: string;
  originalMetaName: string;
  originalPngName: string;
  croppedDataName: string;

  option: IOption;
}

interface IImageCropperState {
  imageMeta: IImageMeta;
}
